export const LOADING_BREADCRUMB = {
    url: '#',
    displayName: 'Loading...'
};
export const ONE_TRUST_SDK_URL = 'one_trust_sdk';
export const CALIFORNIA_PRIVACY_CHOICES_URL = 'https://legal.applovin.com/multistate-privacy-notice';
//# sourceMappingURL=constants.js.map